import type { Metadata } from 'next';
import { fetchMentorshipProgramDetail } from '@/features/mentorship/api/mentorship.api';
import { mapDetailApiToView } from '@/features/mentorship/lib/map-mentorship-views';

/** og:image — Yammer/Facebook зэрэгт бүрэн URL шаардлагатай. */
function absoluteOgImageUrl(urlOrPath: string): string {
  const u = (urlOrPath || '').trim();
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  const base = (process.env.NEXT_PUBLIC_CDN_URL || '').replace(/\/$/, '');
  const path = u.startsWith('/') ? u : `/${u}`;
  return base ? `${base}${path}` : path;
}

export async function buildMentorshipDetailMetadata(
  programId: number
): Promise<Metadata> {
  try {
    const res = await fetchMentorshipProgramDetail(programId);
    const view = mapDetailApiToView(res.data);
    const siteUrl = (
      process.env.NEXT_PUBLIC_APP_SITE_URL || 'https://zangia.mn'
    ).replace(/\/$/, '');
    const pageUrl = `${siteUrl}/mentorship/${programId}`;

    const resolvedOg = absoluteOgImageUrl(view.ogImageUrl);

    const ogImages = [
      {
        url: resolvedOg,
        width: 450,
        height: 300,
        alt: view.listTitle,
      },
    ];

    return {
      title: view.metaTitle,
      description: view.metaDescription,
      keywords: [view.listTitle, 'менторшип', 'internship', 'zangia', 'зангиа'],
      robots: { index: true, follow: true },
      openGraph: {
        title: view.metaTitle,
        description: view.metaDescription,
        images: ogImages,
        type: 'website',
        url: pageUrl,
        siteName: 'Zangia.mn',
        locale: 'mn_MN',
      },
      twitter: {
        card: 'summary_large_image',
        title: view.metaTitle,
        description: view.metaDescription,
        images: [resolvedOg],
        site: '@zangia_mn',
        creator: '@zangia_mn',
      },
      alternates: { canonical: pageUrl },
      metadataBase: new URL(siteUrl),
    };
  } catch {
    return { title: 'Zangia.mn' };
  }
}
